(function () {
    'use strict';

    angular
        .module('roadMeasurements')
        .controller('roadMeasurementsController', roadMeasurementsController);

    roadMeasurementsController.$inject = ['$rootScope', '$scope', 'roadMeasurementsService', 'editService', 'dialogService', 'ArcGISMap'];
    function roadMeasurementsController($rootScope, $scope, roadMeasurementsService, editService, dialogService, ArcGISMap) {
        var vm = this;
        vm.measurementData = {};
        vm.currentPoint = {};
        vm.availableMeasurements = [];
        vm.selectedMeasurement;
        vm.loading = true;
        vm.getNext = getNext;
        vm.getPrevious = getPrevious
        vm.measurementChangeHandler = measurementChangeHandler;

        //helpers
        vm.getDirection = getDirection;
        vm.getRoadway = getRoadway;
        vm.closeSideBar = closeSideBar;
        vm.hasNextValue = hasNextValue;

        $rootScope.$on('toggleMeasurements', function (evt, mapPoint) {
            vm.loading = true;
            if (!$rootScope.Ui.isActive('uiSidebarLeft')) {
                $rootScope.Ui.toggle('uiSidebarLeft');
                ArcGISMap.get().resize();
            }
            editService.resolveRoad(mapPoint.x, mapPoint.y).success(function (roadInfo) {
                roadMeasurementsService.getMeasurement({ km: roadInfo.km, road: roadInfo.kelionr }).success(function (data) {
                    vm.measurementData = data;
                }).error(function () {
                    dialogService.error('Šioje vietoje nepavyko rasti kelio matavimų');
                }).finally(hideLoader);
            }).error(function () {
                dialogService.error('Nepavyko nustatyti kelio');
            });
        });

        $scope.$watch(function () { return vm.measurementData }, function () {
            if (vm.measurementData.dist && vm.measurementData.numeris) {
                roadMeasurementsService.getAllMeasurements({ km: vm.measurementData.dist, road: vm.measurementData.numeris })
                    .success(function (data) {
                        vm.availableMeasurements = data;
                    });
            }
            if (vm.measurementData.gpse && vm.measurementData.gpsn) {
                ArcGISMap.showRoadMeasurement(vm.measurementData.gpse, vm.measurementData.gpsn);
            } else {
                ArcGISMap.hideRoadMeasurement();
            }
        })

        ////////////////

        function getNext() {
            vm.loading = true;
            var next = vm.measurementData.kryptis == 1 ?
                roadMeasurementsService.getNextMeasurement : roadMeasurementsService.getPreviousMeasurement;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };

            next(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti sekančio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }

        function getPrevious() {
            vm.loading = true;
            var previous = vm.measurementData.kryptis == 1 ?
                roadMeasurementsService.getPreviousMeasurement : roadMeasurementsService.getNextMeasurement;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };

            previous(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti ankstesnio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }

        function measurementChangeHandler() {
            vm.loading = true;
            var dataToSend = {
                km: vm.measurementData.dist,
                road: vm.measurementData.numeris,
                date: vm.measurementData.matavimoData
            };
            roadMeasurementsService.getMeasurement(dataToSend).success(function (data) {
                vm.measurementData = data;
            }).error(function () {
                dialogService.error('Nepavyko gauti ankstesnio matavimo arba nebėra matavimų šiame kelyje');
            }).finally(hideLoader);
        }


        function hasNextValue() {
            var measurementGroup = _.find(vm.availableMeasurements, { matavimoData: vm.measurementData.matavimoData });
            if (measurementGroup) {
                var result = { next: true, previous: true }
                if (measurementGroup.kmNuo == vm.measurementData.dist) {
                    vm.measurementData.kryptis == 1 ? result.previous = false : result.next = false;
                }
                if (measurementGroup.kmIki == vm.measurementData.dist) {
                    vm.measurementData.kryptis == 1 ? result.next = false : result.previous = false;
                }
                return result;
            } else {
                return { next: false, previous: false };
            }
        }

        //helpers

        function getRoadway() {
            if (vm.measurementData && vm.measurementData.vazDaliesInfo) {
                if (vm.measurementData.vazDaliesInfo == 1) return 'Viena/pirma važiuojamoji dalis';
                if (vm.measurementData.vazDaliesInfo == 2) return 'Antra važiuojamoji dalis';
            }
            return null;
        }

        function getDirection() {
            if (vm.measurementData && vm.measurementData.kryptis) {
                if (vm.measurementData.kryptis == 1) return 'Kilometražo didejimo kryptis';
                if (vm.measurementData.kryptis == 2) return 'Kilometražo mažejimo kryptis';
            }
            return null;
        }

        function hideLoader() {
            vm.loading = false;
        }

        function closeSideBar() {
            ArcGISMap.get().resize();
            ArcGISMap.hideRoadMeasurement()
        }
    }
})();
